import { Link } from "react-router-dom";
import styles from '../../styles/Components/Shared/BackArrow.module.css';

const backArrowIcon = '/static/img/SvgIcons/backArrow.svg';

const BackArrow = ({linkText, link}) => {
    return (
        <Link to={link} className={styles.back_arrow_container}>
            <img src={backArrowIcon} alt="Back Arrow" />
                    
            {linkText}
        </Link>
    )
}

export default BackArrow;